jQuery(document).ready(function ($) {
  $('.feature-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,   // ✅ always move 1 slide
    infinite: true,
    speed: 600,   // smooth but not too slow
    // cssEase: 'ease-in-out',       
    autoplay: true,
    autoplaySpeed: 5000, // correct autoplay timing
    dots: false,
    arrows: true,
    appendArrows: '.banner-slider-area-nav',

    prevArrow:
      "<button type='button' class='slick-prev'>" +
      "<img src='https://cdn.shopify.com/s/files/1/0706/2431/3479/files/prev.png?v=1766399744' alt='Previous'>" +
      "</button>",

    nextArrow:
      "<button type='button' class='slick-next'>" +
      "<img src='https://cdn.shopify.com/s/files/1/0706/2431/3479/files/next-aarrow.png?v=1766398805' alt='Next'>" +
      "</button>",

    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});


// Open first accordion
document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll(
    '.product__accordion details'
  );

  if (!accordions.length) return;

  const firstAccordion = accordions[0];

  firstAccordion.setAttribute('open', '');

  const wrapper = firstAccordion.closest('.product__accordion');
  if (wrapper) {
    wrapper.classList.add('accordion--first');
  }
});
